var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.useCustomerCategoryModel())?_c('PrizesCustomerCategoryModel',{attrs:{"customItems":_vm.customItems,"homePage":_vm.homePage}}):_c('PrizesDefaultModel',{attrs:{"customItems":_vm.customItems,"homePage":_vm.homePage}})}
var staticRenderFns = []

export { render, staticRenderFns }